// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_-Wl6r","tags-wrapper":"tags-wrapper_oCLJ5"};